import { combineReducers } from "redux";
import registrationReducer from "./reducer";

const combinedReducers = combineReducers({
  registration: registrationReducer,
});

export default combinedReducers;
